import { Dialog, styled } from "@mui/material";

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "550px",
    padding: 24,
  },
  "& .MuiDialogContent-root": {
    padding: 0,
    paddingTop: theme.spacing(1),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    backdropFilter: "blur(2px)",
  },
}));

export default CustomDialog;